import { ElementRef, Injectable } from '@angular/core';
import { RichTextEditorComponent } from '../../components/rich-text-editor/rich-text-editor.component';
import { Focusable } from './focusable';

@Injectable({
  providedIn: 'root',
})
export class AutofocusService {
  private isFocused = false;

  requestFocus(element: Focusable | ElementRef): any {
    if (!this.isFocused) {
      this.setFocus(element);
      this.isFocused = true;
    }
  }

  clear() {
    this.isFocused = false;
  }

  private setFocus(element: Focusable | ElementRef<any>) {
    if ((element as Focusable).setFocus) {
      if (element instanceof RichTextEditorComponent) {
        this.focusRichTextEditor(element as Focusable, 0);
      } else {
        (element as Focusable).setFocus();
      }
    } else {
      (element as ElementRef).nativeElement.focus({ preventScroll: true });
    }
  }

  /**
   * Focusing the TinyMCE rich text editor sometimes fail in unpredictable ways
   * Therefore focusing is retried until successfully executed or until it has been tried 100 times
   */
  private focusRichTextEditor(element: Focusable, tries: number) {
    try {
      element.setFocus();
    } catch (err) {
      if (tries > 100) {
        throw err;
      }
      setTimeout(() => this.focusRichTextEditor(element, tries + 1), 50);
    }
  }
}
